import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Button, FormHelperText, Box } from '@mui/material';

import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import InputText, { InputSelectMultiV2, InputSelectNative } from '../../common/Form';
import Creatable from '../../common/Creatable';
import PostForm from './PostForm';
import axios from 'axios';

class IncomeForm extends Component {
    state = { 
        income_post: this.props.income && this.props.income.income_post ? {
            value: this.props.income.income_post, 
            label: this.props.POSTS[this.props.income.income_post].post_name
        } : {value:"", label:""},
        income_category: this.props.income ? this.props.income.income_category : "",
        income_categoryDisplay: this.props.income && this.props.income.income_category ? {
            value: this.props.income.income_category, 
            label: this.props.CATEGORIES.CHILD[this.props.income.income_category].category_name
        } : {value:"", label:""},
        income_desc: this.props.income ? this.props.income.income_desc : "",
        income_ref: this.props.income ? this.props.income.income_ref : "",
        income_id: this.props.income ? this.props.income.income_id : "",
        income_payment_mode: this.props.income ? this.props.income.income_payment_mode : "",
        income_bank: this.props.income ? this.props.income.income_bank : "",
        income_amount: this.props.income ? parseFloat(this.props.income.income_amount) : "",
        income_files: null,
        income_date: this.props.income ? this.props.income.income_date : new Date(),
        // income_facture_id: this.props.income_facture_id || "",
        income_project: [],
        income_projectID: [],
        require_project: false,
        require_chantier: false,

        errors: {
            income_date: "",
            income_desc: "",
            income_post: "",
            income_category: "",
            income_ref: "",
            income_payment_mode: "",
            income_bank: "",
            income_amount: "",
            income_files: "",
        },
        incomeList: [],
        available: ""
        
    }

    componentDidMount = () => {
        const { LABELS, PROJECTS, income, POSTS } = this.props;
        if( income ){
            // this.fetchChantierInfo()
           
            let projectsDisplay = []
            let projectsID = []
            let require_project = false

            if(!isEmpty(income.income_project)){
                projectsID = income.income_project.split(", ")
                projectsID.map( project => {
                    projectsDisplay.push({
                        value: project,
                        label: PROJECTS[project].project_name,
                        disabled: false ,
                    })
                })
            }

            if (!isEmpty(this.state.income_post) && POSTS[this.state.income_post.value].post_require_project){
                require_project = true
            }
            // if (!isEmpty(this.state.income_post) && this.state.income_post.require_chantier){
            //     required.push("income_chantier")
            // }
            this.setState({
                income_project: projectsDisplay,
                income_projectID: projectsID,
                require_project,
            })

        }
    }
    // fetchChantierInfo = async () => {
    //     const res = await axios.post("/chantiers/spending/part/list", { data: this.props.spending.spending_id })
    //     console.log({res});
    //     if (!isEmpty(res)){
    //         this.setState({spending_chantier_part: res.data})
    //     }

    // }

    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })        
    }

    handleChangeDate = (date) => {
        this.setState({
            income_date: date
        })
    }
    handleChangeSelect = (option, name) => {
        if(option){
            this.setState({
                [name]: option
            })
            if (name === "income_post"){
                this.setState({
                    require_project: option.require_project,
                    require_chantier: option.require_chantier
                })

            }
        } else {
            this.setState({
                [name]: {}
            })
        }
    }
    createNew = (field, name) => {
        this.setState({
            [field]: true,
            nameNew: name
        })
    }
    handleChangeCat = (option) => {
        if(option){
            this.setState({
                income_category: option.value || "",
                income_categoryDisplay: option
            })
        } else {
            this.setState({
                income_category: "",
                income_categoryDisplay: {}
            })

        }
    }
    handleChangeMulti = (option, field) => {
        console.log('====================================');
        console.log({option, field});
        console.log('====================================');
        if(option){
            let IDList = option.map( item => item.value)
            this.setState({                
                [field]: option,
                [`${field}ID`]: IDList,
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
                [`${field}ID`]: [],
            })
        }
    }
    setFiles = (income_files, error = "") => {
        console.log("[INFO] SET_PHOTO", income_files);
        this.setState({
            income_files,
            errors:{
                ...this.state.errors,
                income_files:error
            }
        })
    }
    validate = () => {
        let required = [
            "income_post",
            "income_category",
            "income_amount",
            "income_ref",
            "income_desc",
            "income_payment_mode",
            "income_bank",
            "income_files"
        ]
        if (this.props.update){
            required = [
                "income_post",
                "income_category",
                "income_amount",
                "income_ref",
                "income_desc",
                "income_payment_mode",
                "income_bank",
            ]
        }
        
        if (this.state.require_project){
            required.push("income_project")
        }
        if (this.state.require_chantier){
            required.push("income_chantier")
        }

        let noError = true
        let errors = {}
        
        required.map(field => {
            if( isEmpty(this.state[field]) && !this.state[field] ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else if( field === "income_post" && isEmpty(this.state[field].value)){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        
        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            if(this.props.update){
                data = Object.assign({}, this.props.income)
            } else {
                data.income_files =  this.state.income_files
            }
            data.income_amount =  parseFloat(this.state.income_amount)
            data.income_payment_mode = this.state.income_payment_mode
            data.income_bank =  this.state.income_bank
            data.income_ref =  this.state.income_ref
            data.income_post =  this.state.income_post.value
            data.income_category =  this.state.income_category
            data.income_chantier =  this.state.income_chantier
            data.income_project = isEmpty(this.state.income_project) ? "" : this.state.income_projectID.join(", ")
            // data.income_chantier = this.state.updatedChantier ? "toUpdate" : (isEmpty(this.state.income_chantier) ? "" : this.state.income_chantier.join(", "))
            data.income_date =  this.state.income_date
            data.income_desc =  this.state.income_desc
            // data.income_facture_id =  this.state.income_facture_id
            
            
            console.log('====================================');
            console.log("submit income", {data});
            console.log('====================================');
            
            if (this.props.update) {
                await this.props.updateIncome(data)
            } else {
                await this.props.newIncome(data)
            }
            

            // // if NoErrors ...
            if(this.props.STATE.incomes.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.incomes.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, POSTS, STATE, CATEGORIES, PROJECTS, CHANTIERS } = this.props;
        const { nameNew, formPost} = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth= "md"
                scroll="body"
            >
                {formPost &&
                    <PostForm
                        POSTS={POSTS}
                        STATE={STATE}
                        post={{post_name: nameNew}}
                        handleClose={() => this.setState({ formPost: false, nameNew: "" })}
                        newPost={this.props.newPost}
                        notif={this.props.notif}
                    />
                }
                <DialogTitle id="form-dialog-title">Ajouter une recette</DialogTitle>
                <DialogContent>
                    <Grid container >
                        <Grid item sm={6} xs ={12}>
                            <DatePicker  
                                id="income_date" 
                                label="Date" 
                                name="income_date" 
                                value={this.state.income_date} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.income_date}
                                required
                            />      
                            <Creatable
                                label="Catégorie"
                                required
                                error={this.state.errors.income_category}
                                id="income_category"
                                options={Object.values(CATEGORIES.CHILD).filter(c => c.is_active !== false).map( item => ({
                                    label: item.category_name,
                                    value: item.category_id
                                }))}
                                value={this.state.income_categoryDisplay}
                                openPopUp={this.props.createNewCategory}
                                onChange={this.handleChangeCat}
                                // {...this.props}
                            />
                            <Creatable
                                required
                                label="Poste"
                                error={this.state.errors.income_post}
                                id="income_post"
                                options={Object.values(POSTS).map( item => ({
                                    label: item.post_name,
                                    value: item.post_id,
                                    require_project: item.post_require_project,
                                    require_chantier: item.post_require_chantier,
                                }))}
                                value={this.state.income_post}
                                openPopUp={(name) => this.createNew("formPost", name)}
                                onChange={(option) => this.handleChangeSelect(option, "income_post" )}
                            />
                            {this.state.require_project &&
                                <InputSelectMultiV2
                                    label="Projets"
                                    id="income_project"
                                    options={Object.values(PROJECTS).map( item => ({
                                        label: item.project_name,
                                        value: item.project_id,
                                        disabled: Array.isArray(this.state.income_project) && !!this.state.income_project.find(element => element.value === item.project_id)
                                    }))}
                                    value={this.state.income_project}
                                    onChange={(option) => this.handleChangeMulti(option, "income_project")}
                                    error={this.state.errors.income_project}
                                    isMulti
                                />
                            }
                            <InputSelectNative
                                label="Banque"
                                onChange={this.handleChange}
                                error={this.state.errors.income_bank}
                                value={this.state.income_bank}
                                labelWidth={60} 
                                name="income_bank" 
                                id="income_bank" 
                                options={ Object.values(BANKS).map( bank  => (
                                    <option value={bank.bank_id} key={bank.bank_id}>
                                        {bank.bank_name}
                                    </option>
                                )) }
                            />
                            <InputSelectNative
                                label="Mode de Paiement"
                                value={this.state.income_payment_mode}
                                onChange={this.handleChange}
                                labelWidth={170} 
                                name="income_payment_mode" id="income_payment_mode"
                                error={this.state.errors.income_payment_mode} 
                                options={[
                                    <option value="ESPECES">ESPECES</option>,
                                    <option value="CHEQUE">CHEQUE</option>,
                                    <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                    <option value="VIREMENT">VIREMENT</option>,
                                    <option value="GAB">GAB</option>,
                                    <option value="MOBILE MONEY">MOBILE MONEY</option>
                                ]}
                            />
                            
                            
                        </Grid>
                        <Grid item sm={6} xs ={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="income_desc"
                                error={this.state.errors.income_desc}
                                value={this.state.income_desc}
                                name="income_desc"
                                label="Description"
                                rows={5}
                                multiline
                            />
                            
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="income_amount"
                                error={this.state.errors.income_amount}
                                value={this.state.income_amount}
                                name="income_amount"
                                label="Montant"
                                type="number"          
                            />
                            
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="income_ref"
                                error={this.state.errors.income_ref}
                                value={this.state.income_ref}
                                name="income_ref"
                                label="Référence"
                            />
                        </Grid>
                    </Grid>
                    {!this.props.update &&
                        <Box p={1}>
                            <FileUpload
                                label="Ajouter un Justificatif"
                                setFiles={this.setFiles} 
                                files={this.state.income_files || []} 
                            />
                            <FormControl error={!!this.state.errors.income_files} >
                                <br/>
                                <FormHelperText >{this.state.errors.income_files}</FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        Valider
                    </Button>
                    <Button onClick={this.props.handleClose} >
                        Annuler
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default IncomeForm;